<template>
  <div>
    <navbar back fixed bg>
      <span slot="title">用户解绑</span>
    </navbar>
    <div class="page-content">
      <img class="unbind-img" src="./unbind.png">
      <div class="txt">是否确认解绑</div>
      <div class="btn-group">
        <button class="btn-submit" type="button" @click="unbind">确认</button>
        <button class="btn-cancel" type="button" @click="cancelBind">取消</button>
      </div>
    </div>
    <spinner :show="loading"></spinner>
  </div>
</template>

<script>
  import Navbar from 'components/navbar/navbar'
  import Spinner from 'components/spinner/spinner'

  export default {
    data () {
      return {
        loading: false
      }
    },
    components: {
      Navbar,
      Spinner
    },
    created () {
      if (this.$device.isWechat) {
        let el = document.createElement('script')
        el.src = '//res.wx.qq.com/open/js/jweixin-1.0.0.js'
        document.body.appendChild(el)
      }
    },
    methods: {
      unbind () {
        let vm = this
        this.$dialog({
          type: 'confirm',
          content: '确定要解绑吗？',
          onConfirm () {
            vm._unbind()
          }
        })
      },
      _unbind () {
        let vm = this
        let time = Date.now()
        let params = this.$parseParams(this.$cache.getCache() || '')
        params = this.$assign({}, params, {
          time,
          sign: this.$md5(params.appID + params.msgId + time)
        })
        this.loading = true
        this.$ajax({
          url: '/unBindWx.jhtml',
          params,
          done (o, p, r) {
            vm.$cache.removeUserToken()
            vm.$cache.clearCache()
            vm.$dialog({
              content: r.msg,
              onConfirm () {
                vm.cancelBind()
              }
            })
          },
          fail (m) {
            vm.$dialog(m)
          },
          always () {
            vm.loading = false
          }
        })
      },
      cancelBind () {
        if (this.$device.isWechat && window.wx) {
          window.wx.closeWindow()
        } else {
          this.$router.back()
        }
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '../../common/css/mixmin'

  .page-content
    text-align center
    .unbind-img
      width px2rem(193)
      margin-top px2rem(240)
      margin-bottom px2rem(66)

    .txt
      font-size px2rem(26)
      color #7f868c

    .btn-group
      margin-top px2rem(106)
      width 100%
      font-size px2rem(32)
      button
        width px2rem(222)
        height px2rem(80)
        margin 0 px2rem(30)
        border-radius px2rem(8)
        box-shadow 0 0 px2rem(4) rgba(18,119,163, .75)

      .btn-submit
        color #fff
        border none
        background-color #60c9c8

      .btn-cancel
        color #60c9c8
        border 1px solid #60c9c8
        background-color transparent
</style>



// WEBPACK FOOTER //
// unbind.vue?20b9dc84